<template>
  <div class="view works">
    <div class="view__inner">
      <Hero :msg="heroText" />

      <ul class="cases">
        <li class="case" v-for="item in cases" :key="item.id">
          <CardCase :id="item.id" />
        </li>
      </ul>
    </div>

    <Logos :content="logos" />
    <TheSiteFooterNew />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Hero from "@/components/Hero";
import CardCase from "@/components/CardCase.vue";
import TheSiteFooterNew from "@/components/TheSiteFooterNew.vue";
import Logos from "@/components/Logos.vue";

export default {
  name: "works",
  components: {
    Hero,
    CardCase,
    TheSiteFooterNew,
    Logos
  },
  computed: mapState({
    heroText: state => state.data.worksPage.heading,
    cases: state => state.data.cases,
    logos: state => {
      if (state.data && state.data.logos) {
        return {
          title: state.data.logos.title,
          paragraph: state.data.logos.text,
          items: state.data.logos.item
        };
      }
    }
  }),
  created() {
    this.$store.commit("SET_LIGHT_THEME", true);
  }
};
</script>

<style lang="scss">
@import "../scss/globals.scss";

.works {
  height: 100vh;
  z-index: 2;

  .mobile & {
    height: auto;
  }

  .cases {
    @extend %page-margin-1;

    display: flex;
    flex-wrap: wrap;

    margin: $margin1-1 0 0;

    .case {
      box-sizing: border-box;
      list-style: none;
      width: 100%;

      margin-bottom: $margin1-2;

      @media screen and (min-width: 377px) {
        padding: $margin1-8;
        &:nth-child(odd) {
          padding-left: 0;
        }
        &:nth-child(even) {
          padding-right: 0;
        }
      }

      @media screen and (min-width: 769px) {
        width: 50%;
        margin-bottom: 0;
        padding: $margin1-4;
      }

      @media screen and (min-width: 1025px) {
        padding: 0 $margin1-2 $margin1-1;
      }
    }
  }
}
</style>
